import { createContext, useContext, useState } from 'react';
import { londonAdapter } from '@core/adapters/LondonAdapter';

const RegionContext = createContext();

// Map region IDs to adapters
const adapters = {
  london: londonAdapter,
  // future: nyc: nycAdapter, etc.
};

export const RegionProvider = ({ children, initialRegion = 'london' }) => {
  const [regionId, setRegionId] = useState(initialRegion);
  const adapter = adapters[regionId];
  if (!adapter) {
    throw new Error(`Unknown region: ${regionId}`);
  }
  return (
    <RegionContext.Provider value={{ regionId, setRegionId, adapter }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => {
  const ctx = useContext(RegionContext);
  if (!ctx) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return ctx;
};